import Cursor from './cursor';
import ButtonCtrl from './buttonCtrl';

// initialize custom cursor
const cursor = new Cursor(document.querySelector('.magneticCursor'));
// const button = new ButtonCtrl(document.querySelector('.magneticButton'));

const button1 = new ButtonCtrl(document.querySelector('.magneticBtn1'));
const button2 = new ButtonCtrl(document.querySelector('.magneticBtn2'));
const button3 = new ButtonCtrl(document.querySelector('.magneticBtn3'));

button1.on('enter', () => cursor.enter());
button1.on('leave', () => cursor.leave());

button2.on('enter', () => cursor.enter());
button2.on('leave', () => cursor.leave());

button3.on('enter', () => cursor.enter());
button3.on('leave', () => cursor.leave());

// FOOTER 

// const buttonFooter1 = new ButtonCtrl(document.querySelector('.magneticFooterBtn1'));
// const buttonFooter2 = new ButtonCtrl(document.querySelector('.magneticFooterBtn2'));
// const buttonFooter3 = new ButtonCtrl(document.querySelector('.magneticFooterBtn3'));

// buttonFooter1.on('enter', () => cursor.enter());
// buttonFooter1.on('leave', () => cursor.leave());

// buttonFooter2.on('enter', () => cursor.enter());
// buttonFooter2.on('leave', () => cursor.leave());

// buttonFooter3.on('enter', () => cursor.enter());
// buttonFooter3.on('leave', () => cursor.leave());